// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"styles_containerRoot__YNELT","textLetter":"styles_textLetter__E5sIR","textActiveLetter":"styles_textActiveLetter__PGSxt"};